import { useEffect, useState } from "react"
import { Loader } from "semantic-ui-react"

interface Props extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {}

const Image: React.FC<Props> = (props) => {
  const [isLoadingImage, setIsLoadingImage] = useState<boolean>(true)
  const [isError, setIsError] = useState<boolean>(false)

  useEffect(() => {
    setIsLoadingImage(true)
    setIsError(false)
  }, [])

  const handleImageLoad = () => {
    setIsLoadingImage(false)
  }

  const handleImageError = () => {
    setIsLoadingImage(false)
    setIsError(true)
  }
  return (
    <div className="w-full h-full">
      {isLoadingImage && (
        <div className="absolute inset-0 flex justify-center items-center  z-10">
          <Loader active size="huge">
            Loading Image
          </Loader>
        </div>
      )}
      {isError ? (
        <div className="flex justify-center items-center w-full h-full">
          <p className="text-red-500">Failed to load the image.</p>
        </div>
      ) : (
        <img
          className={`object-contain w-full h-full ease-in-out border ${
            isLoadingImage ? "blur-xl opacity-50" : "blur-0 opacity-100"
          }`}
          onLoad={handleImageLoad}
          onError={handleImageError}
          loading="lazy"
          {...props}
        />
      )}
    </div>
  )
}

export default Image
